import ReserveVue from '@/views/member/reservation/reservation.vue';

const basePath = '/member/reservation';
const role = 'member'; // 角色身份

export const M_RESERVATION_INDEX = 'm-reservation-index';
export const M_RESERVATION_EDIT = 'm-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReserveVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: M_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation-edit" */
        `@/views/${role}/reservation/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
